import { Component, OnInit, computed, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';
import { MessageService } from 'primeng/api';
import { BusquedaClienteDialogComponent, ClienteSeleccionado } from '../common/busquedas/busqueda-cliente-dialog.component';
import { AsesorSeleccionado, BusquedaAsesorDialogComponent as AsesorSearchComponent } from '../common/busquedas/busqueda-asesor-dialog.component';
import { Persona, getNombreCompleto } from 'src/app/domain/model/persona/persona';
import { PersonaRepository } from 'src/app/domain/service/persona/persona-repository';
import { BeneficiarioRepository } from 'src/app/domain/service/beneficiario/beneficiario-repository';
import { CatalogoOption } from 'src/app/domain/model/catalogo/catalogo';
import { CatalogoRepository } from 'src/app/domain/service/catalogo/catalogo-repository';

type MessageType = 'info' | 'warning' | 'error';

interface InformacionEmpresaAccion {
  key: string;
  titulo: string;
  descripcion: string;
  icono: string;
  color: string;
  ruta: string;
}

@Component({
  selector: 'app-informacion-empresa',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    ButtonModule,
    SelectModule,
    TooltipModule,
    BusquedaClienteDialogComponent,
    AsesorSearchComponent
  ],
  providers: [MessageService],
  template: `
    <div class="p-3 sm:p-6 max-w-7xl mx-auto">
      <div class="mb-6">
        <h1 class="text-xl sm:text-2xl font-bold text-gray-800 dark:text-gray-100 mb-2">Información Empresa</h1>
      </div>

      <div class="border border-gray-200 dark:border-gray-700 rounded p-3 sm:p-4 mb-5 bg-gray-50 dark:bg-gray-800 transition-colors duration-300">
        <div class="font-medium text-gray-700 dark:text-gray-200 mb-3 text-sm">Parámetros de Consulta</div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div class="md:col-span-2">
            <label class="block text-sm text-gray-600 dark:text-gray-300 mb-1">Cliente</label>
            <div class="grid grid-cols-1 lg:grid-cols-[15ch_15ch_minmax(0,1fr)] gap-2">
              <div>
                <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1">Contrato</label>
                <input pInputText [value]="clienteContratoDisplay()" class="w-full" readonly />
              </div>
              <div>
                <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1">Documento</label>
                <input pInputText [value]="clienteDocumentoDisplay()" class="w-full" readonly />
              </div>
              <div>
                <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1">Nombre</label>
                <div class="flex gap-2 min-w-0 ">
                  <input pInputText [value]="clienteNombreDisplay()" class="flex-1 min-w-0" readonly />
                  <button
                    type="button"
                    pButton
                    icon="pi pi-search"
                    class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                    pTooltip="Buscar cliente"
                    tooltipPosition="left"
                    size="small"
                    (click)="abrirBusquedaCliente()">
                  </button>
                  @if (clienteSeleccionado()) {
                    <button
                      type="button"
                      pButton
                      icon="pi pi-times"
                      class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                      severity="danger"
                      size="small"
                      pTooltip="Limpiar cliente"
                      tooltipPosition="left"
                      (click)="limpiarCliente()">
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>

          <div class="md:col-span-2">
            <label class="block text-sm text-gray-600 dark:text-gray-300 mb-1">Consultor</label>
            <div class="grid grid-cols-1 lg:grid-cols-[15ch_15ch_minmax(0,1fr)] gap-2">
              <div>
                <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1">Tipo documento</label>
                <p-select
                  [options]="tiposIdentificacionDisponibles()"
                  optionLabel="descripcion"
                  optionValue="codigo"
                  [ngModel]="consultorTipoDocumentoSeleccionado()"
                  [showClear]="false"
                  [filter]="false"
                  [disabled]="true"
                  placeholder=""
                  [style]="{ width: '100%' }"
                  appendTo="body">
                </p-select>
              </div>
              <div>
                <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1">Número documento</label>
                <input pInputText [value]="consultorNumeroDocumentoDisplay()" class="w-full" readonly />
              </div>
              <div>
                <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1">Nombre</label>
                <div class="flex gap-2 min-w-0 ">
                  <input pInputText [value]="consultorNombreDisplay()" class="flex-1 min-w-0" readonly />
                  <button
                    type="button"
                    pButton
                    icon="pi pi-search"
                    class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                    pTooltip="Buscar consultor"
                    tooltipPosition="left"
                    size="small"
                    (click)="abrirBusquedaConsultor()">
                  </button>
                  @if (consultorSeleccionado()) {
                    <button
                      type="button"
                      pButton
                      icon="pi pi-times"
                      class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                      severity="danger"
                      pTooltip="Limpiar consultor"
                      tooltipPosition="left"
                      size="small"
                      (click)="limpiarConsultor()">
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      @if (mensaje()) {
        <div class="p-3 mb-4 rounded"
          [ngClass]="{
            'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-200': mensajeTipo() === 'info',
            'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-200': mensajeTipo() === 'warning',
            'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-200': mensajeTipo() === 'error'
          }">
          <i class="pi mr-2"
            [ngClass]="{
              'pi-info-circle': mensajeTipo() === 'info',
              'pi-exclamation-triangle': mensajeTipo() === 'warning',
              'pi-times-circle': mensajeTipo() === 'error'
            }"></i>
          {{ mensaje() }}
        </div>
      }

      <div class="mb-4 flex items-center gap-2 text-sm">
        <span class="text-gray-500 dark:text-gray-400">
          Selecciona un cliente o consultor para activar el dashboard.
        </span>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-4">
        @for (accion of acciones; track accion.key) {
          <button
            type="button"
            class="group text-left rounded-lg border p-4 transition-all duration-200"
            [ngClass]="[
              accionesHabilitadas()
                ? accion.color + ' hover:shadow-md hover:-translate-y-0.5 cursor-pointer'
                : 'bg-gray-100 border-gray-200 text-gray-400 opacity-70 cursor-not-allowed'
            ]"
            [disabled]="!accionesHabilitadas()"
            (click)="irAccion(accion.ruta)">
            <div class="text-2xl mb-2">{{ accion.icono }}</div>
            <div class="font-semibold mb-1">{{ accion.titulo }}</div>
            <div class="text-xs opacity-90">{{ accion.descripcion }}</div>
          </button>
        }
      </div>

      @if (mostrarBuscadorCliente) {
        <app-busqueda-cliente-dialog
          [titulo]="'Buscar Cliente / Beneficiario'"
          (onSelect)="onClienteSeleccionado($event)"
          (onClose)="cerrarBusquedaCliente()">
        </app-busqueda-cliente-dialog>
      }

      @if (mostrarBuscadorConsultor) {
        <app-asesor-search
          (onSelect)="seleccionarConsultor($event)"
          (onClose)="cerrarBusquedaConsultor()" />
      }
    </div>
  `
})
export class InformacionEmpresaComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly personaRepository = inject(PersonaRepository);
  private readonly beneficiarioRepository = inject(BeneficiarioRepository);
  private readonly catalogoRepository = inject(CatalogoRepository);

  readonly acciones: InformacionEmpresaAccion[] = [
    {
      key: 'historial',
      titulo: 'Historial de gestiones',
      descripcion: 'Consulta de gestiones registradas por contexto.',
      icono: '📒',
      color: 'bg-blue-400 border-blue-200 text-blue-800',
      ruta: '/informacion-empresa/historial-gestiones'
    },
    {
      key: 'consultoria',
      titulo: 'Ordenado por consultoría',
      descripcion: 'Listado de órdenes para análisis de consultoría.',
      icono: '📑',
      color: 'bg-indigo-400 border-indigo-200 text-indigo-800',
      ruta: '/informacion-empresa/ordenado-consultoria'
    },
    {
      key: 'citas',
      titulo: 'Citas programadas',
      descripcion: 'Seguimiento de citas asociadas a la consulta.',
      icono: '📅',
      color: 'bg-green-400 border-green-200 text-green-800',
      ruta: '/informacion-empresa/citas-programadas'
    },
    {
      key: 'servicios',
      titulo: 'Servicios entregados',
      descripcion: 'Consulta de servicios/facturación entregada.',
      icono: '🧾',
      color: 'bg-orange-400 border-orange-200 text-orange-800',
      ruta: '/informacion-empresa/servicios-entregados'
    },
    {
      key: 'informes',
      titulo: 'Informes entregados',
      descripcion: 'Revisión de informes y trazabilidad documental.',
      icono: '📘',
      color: 'bg-purple-400 border-purple-200 text-purple-800',
      ruta: '/informacion-empresa/informes-entregados'
    }
  ];

  readonly clienteSeleccionado = signal<ClienteSeleccionado | null>(null);
  readonly consultorSeleccionado = signal<Persona | null>(null);

  readonly consultoresResultado = signal<Persona[]>([]);
  readonly loadingConsultorBusqueda = signal(false);
  readonly tiposIdentificacion = signal<CatalogoOption[]>([]);

  readonly mensaje = signal('');
  readonly mensajeTipo = signal<MessageType>('info');

  mostrarBuscadorCliente = false;
  mostrarBuscadorConsultor = false;

  readonly accionesHabilitadas = computed(() => {
    return Boolean(this.clienteSeleccionado() || this.consultorSeleccionado());
  });

  readonly clienteContratoDisplay = computed(() => {
    const cliente = this.clienteSeleccionado();
    return cliente?.contrato ?? '';
  });

  readonly clienteDocumentoDisplay = computed(() => {
    const cliente = this.clienteSeleccionado();
    if (!cliente) {
      return '';
    }

    const tipo = cliente.descTipoIdentificacion ?? cliente.tipoIdentificacion;
    if (!tipo && !cliente.numeroIdentificacion) {
      return '';
    }
    return `${tipo ?? ''} ${cliente.numeroIdentificacion ?? ''}`.trim();
  });

  readonly clienteNombreDisplay = computed(() => {
    const cliente = this.clienteSeleccionado();
    return cliente?.nombreComercial ?? '';
  });

  readonly consultorTipoDocumentoDisplay = computed(() => {
    const consultor = this.consultorSeleccionado();
    return consultor?.cdtipo_identificacion ?? '';
  });

  readonly consultorTipoDocumentoSeleccionado = computed(
    () => this.consultorSeleccionado()?.cdtipo_identificacion ?? null
  );

  readonly tiposIdentificacionDisponibles = computed(() => {
    const opciones = this.tiposIdentificacion();
    const seleccionado = this.consultorTipoDocumentoSeleccionado();

    if (!seleccionado) {
      return opciones;
    }

    const existeSeleccion = opciones.some((opcion) => opcion.codigo === seleccionado);
    if (existeSeleccion) {
      return opciones;
    }

    return [{ codigo: seleccionado, descripcion: seleccionado }, ...opciones];
  });

  readonly consultorNumeroDocumentoDisplay = computed(() => {
    const consultor = this.consultorSeleccionado();
    return consultor?.nmidentificacion ?? consultor?.dni ?? '';
  });

  readonly consultorNombreDisplay = computed(() => {
    const consultor = this.consultorSeleccionado();
    if (!consultor) {
      return '';
    }

    const nombre = getNombreCompleto(consultor).trim();
    return nombre || consultor.nombreCompleto?.trim() || '';
  });

  constructor() {
    this.precargarClienteDesdeEntrada();
    this.precargarConsultorDesdeEntrada();
  }

  ngOnInit(): void {
    void this.inicializar();
  }

  private async inicializar(): Promise<void> {
    await Promise.all([this.hidratarClienteDesdeConsecutivo(), this.cargarTiposIdentificacion()]);
  }

  abrirBusquedaCliente(): void {
    this.mostrarBuscadorCliente = true;
  }

  cerrarBusquedaCliente(): void {
    this.mostrarBuscadorCliente = false;
  }

  onClienteSeleccionado(cliente: ClienteSeleccionado): void {
    this.clienteSeleccionado.set(cliente);
    this.mostrarBuscadorCliente = false;
    this.mensaje.set('');
  }

  limpiarCliente(): void {
    this.clienteSeleccionado.set(null);
  }

  abrirBusquedaConsultor(): void {
    this.mostrarBuscadorConsultor = true;
  }

  async seleccionarConsultor(consultor: Persona | AsesorSeleccionado): Promise<void> {
    this.consultorSeleccionado.set(this.mapAsesorToPersona(consultor));
    this.consultoresResultado.set([]);
    this.mostrarBuscadorConsultor = false;
    this.mensaje.set('');
  }

  limpiarBusquedaConsultor(): void {
    this.consultoresResultado.set([]);
  }

  cerrarBusquedaConsultor(): void {
    this.mostrarBuscadorConsultor = false;
    this.consultoresResultado.set([]);
  }

  limpiarConsultor(): void {
    this.consultorSeleccionado.set(null);
    this.consultoresResultado.set([]);
  }

  irAccion(ruta: string): void {
    if (!this.accionesHabilitadas()) {
      this.mostrarMensaje('warning', 'Debes seleccionar cliente/beneficiario o consultor para continuar.');
      return;
    }

    this.router.navigate([ruta], {
      queryParams: this.construirContextoNavegacion()
    });
  }

  private construirContextoNavegacion(): Record<string, string | number> {
    const contexto: Record<string, string | number> = {};

    const cliente = this.clienteSeleccionado();
    if (cliente) {
      contexto['nmconsecutivoBeneficiario'] = cliente.nmconsecutivo;
      contexto['cdpersonaBeneficiario'] = cliente.cdpersona;
      contexto['tipoIdentificacionBeneficiario'] = cliente.tipoIdentificacion;
      contexto['numeroIdentificacionBeneficiario'] = cliente.numeroIdentificacion;
      contexto['nombreBeneficiario'] = cliente.nombreComercial;
      if (cliente.contrato) {
        contexto['contratoBeneficiario'] = cliente.contrato;
      }
    }

    const consultor = this.consultorSeleccionado();
    if (consultor) {
      if (consultor.nmconsecutivo != null) {
        contexto['nmconsecutivoConsultor'] = consultor.nmconsecutivo;
      }
      if (consultor.cdpersona != null) {
        contexto['cdpersonaConsultor'] = consultor.cdpersona;
      }
      if (consultor.cdtipo_identificacion) {
        contexto['tipoIdentificacionConsultor'] = consultor.cdtipo_identificacion;
      }
      if (consultor.nmidentificacion) {
        contexto['numeroIdentificacionConsultor'] = consultor.nmidentificacion;
      }
      const nombre = getNombreCompleto(consultor);
      if (nombre) {
        contexto['nombreConsultor'] = nombre;
      }
    }

    return contexto;
  }

  private precargarClienteDesdeEntrada(): void {
    const query = this.route.snapshot.queryParamMap;
    const state = globalThis.history.state as Record<string, unknown>;

    const nmconsecutivo = this.toNumber(query.get('nmconsecutivoBeneficiario'))
      ?? this.toNumber(state['nmconsecutivoBeneficiario']);

    if (!nmconsecutivo) {
      return;
    }

    const nombre = query.get('nombreBeneficiario')
      ?? this.toStringOrEmpty(state['nombreBeneficiario']);
    const tipoId = query.get('tipoIdentificacionBeneficiario')
      ?? this.toStringOrEmpty(state['tipoIdentificacionBeneficiario']);
    const numId = query.get('numeroIdentificacionBeneficiario')
      ?? this.toStringOrEmpty(state['numeroIdentificacionBeneficiario']);
    const contrato = this.obtenerContratoDesdeEntrada(query, state);
    const cdpersona = this.toNumber(query.get('cdpersonaBeneficiario'))
      ?? this.toNumber(state['cdpersonaBeneficiario'])
      ?? 0;

    this.clienteSeleccionado.set({
      nmconsecutivo,
      cdpersona,
      tipoIdentificacion: tipoId,
      numeroIdentificacion: numId,
      nombreComercial: nombre,
      contrato: contrato || undefined
    });
  }

  private precargarConsultorDesdeEntrada(): void {
    const query = this.route.snapshot.queryParamMap;
    const state = globalThis.history.state as Record<string, unknown>;

    const nmconsecutivo = this.toNumber(query.get('nmconsecutivoConsultor'))
      ?? this.toNumber(state['nmconsecutivoConsultor']);
    const cdpersona = this.toNumber(query.get('cdpersonaConsultor'))
      ?? this.toNumber(state['cdpersonaConsultor']);

    if (!nmconsecutivo && !cdpersona) {
      return;
    }

    const tipoId = query.get('tipoIdentificacionConsultor')
      ?? this.toStringOrEmpty(state['tipoIdentificacionConsultor']);
    const numId = query.get('numeroIdentificacionConsultor')
      ?? this.toStringOrEmpty(state['numeroIdentificacionConsultor']);
    const nombre = query.get('nombreConsultor')
      ?? this.toStringOrEmpty(state['nombreConsultor']);

    this.consultorSeleccionado.set({
      nmconsecutivo: nmconsecutivo ?? undefined,
      cdpersona: cdpersona ?? undefined,
      cdtipo_identificacion: tipoId || undefined,
      nmidentificacion: numId || undefined,
      dni: numId || undefined,
      nombreCompleto: nombre || undefined
    });
  }

  private async cargarTiposIdentificacion(): Promise<void> {
    try {
      const tipos = await this.catalogoRepository.getTiposIdentificacion();
      this.tiposIdentificacion.set(tipos ?? []);
    } catch {
      this.tiposIdentificacion.set([]);
    }
  }

  private mapAsesorToPersona(consultor: Persona | AsesorSeleccionado): Persona {
    if ('cdtipoIdentificacion' in consultor) {
      const asesor = consultor as AsesorSeleccionado;
      return {
        nmconsecutivo: asesor.nmconsecutivo,
        cdpersona: asesor.cdpersona,
        cdtipo_identificacion: asesor.cdtipoIdentificacion,
        nmidentificacion: asesor.nmidentificacion,
        dsnombre1: asesor.dsnombre1,
        dsnombre2: asesor.dsnombre2,
        dsapellido1: asesor.dsapellido1,
        dsapellido2: asesor.dsapellido2,
        dsnombre_comercial: asesor.dsnombreComercial,
        snactivo: asesor.snactivo,
        dni: asesor.nmidentificacion,
        nombreCompleto: getNombreCompleto({
          dsnombre1: asesor.dsnombre1,
          dsnombre2: asesor.dsnombre2,
          dsapellido1: asesor.dsapellido1,
          dsapellido2: asesor.dsapellido2
        })
      };
    }

    return consultor as Persona;
  }

  private async hidratarClienteDesdeConsecutivo(): Promise<void> {
    const cliente = this.clienteSeleccionado();
    if (!cliente?.nmconsecutivo) {
      return;
    }

    const requiereHidratacion =
      !cliente.nombreComercial
      || !cliente.tipoIdentificacion
      || !cliente.numeroIdentificacion
      || !cliente.contrato;
    if (!requiereHidratacion) {
      return;
    }

    const beneficiario = await this.beneficiarioRepository.obtenerPorConsecutivo(cliente.nmconsecutivo);
    if (!beneficiario) {
      return;
    }

    this.clienteSeleccionado.set({
      nmconsecutivo: beneficiario.nmconsecutivo,
      cdpersona: beneficiario.cdpersona,
      tipoIdentificacion: beneficiario.tipoIdentificacion,
      descTipoIdentificacion: beneficiario.descTipoIdentificacion,
      numeroIdentificacion: beneficiario.numeroIdentificacion,
      nombreComercial: beneficiario.nombreComercial,
      contrato: beneficiario.cdcontrato ?? cliente.contrato
    });
  }

  private obtenerContratoDesdeEntrada(
    query: ActivatedRoute['snapshot']['queryParamMap'],
    state: Record<string, unknown>
  ): string {
    return (
      query.get('contratoBeneficiario')
      ?? query.get('cdcontratoBeneficiario')
      ?? query.get('dscontratoBeneficiario')
      ?? this.toStringOrEmpty(state['contratoBeneficiario'])
      ?? this.toStringOrEmpty(state['cdcontratoBeneficiario'])
      ?? this.toStringOrEmpty(state['dscontratoBeneficiario'])
      ?? ''
    ).trim();
  }

  private mostrarMensaje(tipo: MessageType, texto: string): void {
    this.mensajeTipo.set(tipo);
    this.mensaje.set(texto);
  }

  private toNumber(value: unknown): number | null {
    if (value == null || value === '') {
      return null;
    }

    const numero = Number(value);
    return Number.isFinite(numero) ? numero : null;
  }

  private toStringOrEmpty(value: unknown): string {
    return typeof value === 'string' ? value : '';
  }
}
